/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Rag_Scope_Point_3Inputs */

const en_svc_rag_scope_point_3 = /** @type {(inputs: Svc_Rag_Scope_Point_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search and summaries across contracts, manuals and tickets`)
};

const lv_svc_rag_scope_point_3 = /** @type {(inputs: Svc_Rag_Scope_Point_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meklēšana un kopsavilkumi līgumos, rokasgrāmatās un pieteikumos`)
};

/**
* | output |
* | --- |
* | "Search and summaries across contracts, manuals and tickets" |
*
* @param {Svc_Rag_Scope_Point_3Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_rag_scope_point_3 = /** @type {((inputs?: Svc_Rag_Scope_Point_3Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Rag_Scope_Point_3Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_rag_scope_point_3(inputs)
	return en_svc_rag_scope_point_3(inputs)
});